import _ from 'lodash';
import * as React from 'react'
import * as ReactDOMServer from 'react-dom/server';

import { getSeason } from '../../../services/getSeason';
import { WeatherSearchResultRowComplete } from '../../../services/weatherSearch';
import { InfoSectionForMap } from '../../shared/card/info-section-for-map'
import isTouchScreen from '../../../services/isTouchScreen';
import { TooltipOptions } from 'leaflet';
import { MonthIndexChart } from './month-index-chart';

export const generateTooltip = ({ result, toBeOpened, marker, unit, isForImage, isTouch, clickHandler }: { result: WeatherSearchResultRowComplete, toBeOpened?: boolean, marker: L.Marker | L.CircleMarker, unit: string, isForImage: boolean, isTouch: boolean, clickHandler?: (marker: L.CircleMarker | L.Marker) => void }) => {
    if (marker.getTooltip()) {
        marker.unbindTooltip();
    }
    const url = `/thumbs-renamed/${result.mainImgData.url.replace('.jpg', '.png')}`;
    const content = ReactDOMServer.renderToStaticMarkup(
        <MapInfoBox url={url} row={result} unit={unit} bigSize={!toBeOpened} isForImage={isForImage} isTouch={isTouch} />
    );
    let offset = isForImage ? -32 : -8;
    const options: TooltipOptions = {

        offset: [0, offset],
        interactive: true,
        permanent: toBeOpened,
        direction: "top",
        opacity: 0.97,
        className: `shadow-standart bg-white p-0 rounded-md ${isTouchScreen() && 'touch'}`
    }
    marker.bindTooltip(content, options);
    const onTooltipClick = () => {
        if (clickHandler) {
            clickHandler(marker);
        }
    }
    const tooltipEl = marker.getTooltip().getElement()
    if (tooltipEl) {
        tooltipEl.onclick = onTooltipClick;
    }
    marker.on('tooltipopen', () => {
        const el = marker.getTooltip().getElement();
        el.onclick = onTooltipClick;
    })


    return marker.getTooltip();
}

export const MapInfoBox = ({ url, row, unit, bigSize, isTouch }: { url: string, row: WeatherSearchResultRowComplete, unit: string, bigSize?: boolean, isForImage: boolean, isTouch: boolean }) => {
    const isMonth = !row.monthIndexes;
    return (
        <div className={`info-box inline-flex gap-[10px] min-w-[110px] w-max  ${!bigSize ? 'max-w-[210px]' : 'max-w-[250px] md:max-w-[300px] xl:max-w-[350px]'}  ${bigSize ? "h-[80px] px-[8px] " : `${isMonth ? 'h-[52px]' : 'h-[64px]'} py-[6px] px-[8px]`} items-center`}>
            {bigSize && <img src={url} className="w-[64px] h-[64px] rounded-md" />}
            <div className={`flex flex-col min-w-0 flex-auto items-center ${bigSize && (!isTouch || isMonth) && 'text-[16px]'} ${isTouch && 'items-stretch gap-[4px]'}`}>
                <div className={`min-w-0 font-b text-center info-box-name transition-colors max-w-full ${isTouch ? 'text-left' : 'text-center'}`}>
                    <div className="text-ellipsis whitespace-nowrap overflow-hidden">{row.name}</div>
                </div>
                <PossibleTouchWrapper applyWrapper={isTouch && isMonth}>
                    {isMonth && <InfoSectionForMap unit={unit} amount={row.tmax[1]} season={getSeason({ wet: row.wet })} bigSize={bigSize} />}
                    {!isMonth && <div className='flex flex-col items-center text-zinc-500 '>
                        <MonthIndexChart monthIndexes={row.monthIndexes} className='w-[120px] md:w-[140px]' />
                    </div>}
                    {isTouch && isMonth && <TouchButton smaller={!bigSize} />}
                </PossibleTouchWrapper >

            </div >
            {isTouch && !isMonth && <TouchButton />}

        </div >
    )
}

const PossibleTouchWrapper = ({ applyWrapper, children }: { applyWrapper: boolean, children: React.ReactNode }) => {
    return !applyWrapper ? <>{children}</> :
        <div className='flex flex-row justify-between items-center gap-[15px]'>{children}</div>
}

const TouchButton = ({ smaller }: { smaller?: boolean }) => {
    return (
        <div className={`bg-sh-red white rounded-lg w-[32px] ${smaller ? "h-[24px] text-[16px] leading-[24px]" : "h-[32px] text-[18px] leading-[30px]"} font-bold  text-white text-center  shrink-0`}>{'>'}</div>
    );
}
